import { formatFullTime } from "../core/TimeScale";
import { PALETTE } from "../core/Theme";
import type { Frame } from "./Frame";

export interface CrosshairState { x: number; y: number; active: boolean }

export function renderCrosshair(f: Frame, cr: CrosshairState, tool = "cross") {
  const { ctx, L, tc, opts } = f;
  if (!cr.active || cr.x <= L.plotLeft || cr.x >= L.plotRight) return;
  ctx.strokeStyle = PALETTE.crosshair;
  ctx.setLineDash([3, 3]); ctx.lineWidth = 1;
  if (tool === "dot") {
    ctx.setLineDash([]); ctx.fillStyle = PALETTE.amber;
    ctx.beginPath(); ctx.arc(cr.x, cr.y, 3, 0, Math.PI * 2); ctx.fill();
  } else if (tool === "eraser") {
    ctx.setLineDash([]); ctx.strokeStyle = "#FF3B30";
    ctx.beginPath(); ctx.arc(cr.x, cr.y, 7, 0, Math.PI * 2); ctx.stroke();
  } else {
    ctx.beginPath(); ctx.moveTo(cr.x, L.plotTop); ctx.lineTo(cr.x, L.h - L.bottomAxis); ctx.stroke();
  }
  if (cr.y < L.priceBottom) {
    if (tool === "cross" || tool === "arrow") { ctx.setLineDash([3, 3]); ctx.strokeStyle = PALETTE.crosshair; ctx.beginPath(); ctx.moveTo(L.plotLeft, cr.y); ctx.lineTo(L.plotRight, cr.y); ctx.stroke(); }
    ctx.fillStyle = PALETTE.amber;
    ctx.fillRect(L.plotRight, cr.y - 9, L.rightAxis, 18);
    ctx.fillStyle = tc.lastLabelText;
    ctx.font = `11px ${PALETTE.mono}`;
    ctx.textAlign = "left"; ctx.textBaseline = "middle";
    ctx.fillText(f.priceAt(cr.y).toFixed(opts.decimals), L.plotRight + 5, cr.y);
  }
  ctx.setLineDash([]);
  const idx = f.indexAt(cr.x);
  const c = f.candles[idx];
  const x = c ? f.x(idx) : cr.x;
  const label = formatFullTime(c ? c.time : f.timeAt(cr.x));
  ctx.font = `11px ${PALETTE.mono}`;
  ctx.fillStyle = PALETTE.amber;
  const tw = ctx.measureText(label).width + 12;
  ctx.fillRect(x - tw / 2, L.h - L.bottomAxis, tw, L.bottomAxis);
  ctx.fillStyle = tc.lastLabelText;
  ctx.textAlign = "center"; ctx.textBaseline = "middle";
  ctx.fillText(label, x, L.h - L.bottomAxis / 2);
}
